export default __webpack_public_path__ + "static/media/single-project-page-01-img7.e41bde54.jpg";